<template>
  <div id="mmstyle-request-modal" class="modal"  v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2 v-if="!isComfirm">mmstyle 公開申請入力画面</h2>
        <h2 v-else>mmstyle 公開申請確認画面</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li class="sub-menu">
            <span>★公開プラン情報</span>
          </li>
          <li>
            <span class="label">UM_CODE</span>
            <span>{{ fileData.fileCode }}</span>
          </li>
          <li>
            <span class="label">ファイル名</span>
            <span>{{ fileData.fileName }}</span>
          </li>
          <li class="sub-menu">
            <span>★商品情報設定</span>
          </li>
          <li>
            <span class="label">カテゴリ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.dcCategoryType">
              <option v-for="(category, index) in categoryList" v-bind:key="index" :value="category.code">{{category.label}}</option>
            </select>
            <span v-else>{{ categoryList[form.dcCategoryType-1].label }}</span>
          </li>
          <li>
            <span class="label">商品並び順<span v-if="!isComfirm" class="required">【必須】</span></span>
            <input v-if="!isComfirm" type="number" v-model="form.dcFdOrderNo"/>
            <span v-else>{{ form.dcFdOrderNo }}</span>
          </li>
          <li>
            <span class="label">配送日数<span v-if="!isComfirm" class="required">【必須】</span></span>
            <input v-if="!isComfirm" type="number" v-model="form.dcDeliveryDay"/>
            <span v-else>{{ form.dcDeliveryDay }}</span>
          </li>
          <li>
            <span class="label">デジタルカタログ名<span v-if="!isComfirm" class="required">【必須】</span></span>
            <input v-if="!isComfirm" type="text" v-model="form.dcFdName"/>
            <span v-else>{{ form.dcFdName }}</span>
          </li>
          <li>
            <span class="label">デジタルカタログ説明(内部用)</span>
            <input v-if="!isComfirm" type="text" v-model="form.dcCaption"/>
            <span v-else>{{ form.dcCaption }}</span>
          </li>
          <li>
            <span class="label">商品設定タイプ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.dcFdType">
              <option v-for="(item, index) in itemTypeList" v-bind:key="index" :value="item.code">{{item.label}}</option>
            </select>
            <span v-else>{{ itemTypeList[form.dcFdType-1].label }}</span>
          </li>
          <li>
            <span class="label">商品カラータイプ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.dcFdColorType">
              <option v-for="(color, index) in colorList" v-bind:key="index" :value="color.cdcColorTypeNo">{{color.cdcColorTypeName}}</option>
            </select>
            <span v-else>{{ getColorName(form.dcFdColorType) }}</span>
          </li>
          <li class="sub-menu">
            <span>★フラグ設定</span>
          </li>
          <li>
            <span class="label">Bタイプ選択不可フラグ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.btypeDisableFlg">
              <option v-for="(enable, index) in enableList" v-bind:key="index" :value="enable.code">{{enable.label}}</option>
            </select>
            <span v-else>{{ getEnableName(form.btypeDisableFlg) }}</span>
          </li>
          <li>
            <span class="label">Cタイプ選択不可フラグ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.ctypeDisableFlg">
              <option v-for="(enable, index) in enableList" v-bind:key="index" :value="enable.code">{{enable.label}}</option>
            </select>
            <span v-else>{{ getEnableName(form.ctypeDisableFlg)}}</span>
          </li>
          <li>
            <span class="label">Dタイプ選択不可フラグ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.dtypeDisableFlg">
              <option v-for="(enable, index) in enableList" v-bind:key="index" :value="enable.code">{{enable.label}}</option>
            </select>
            <span v-else>{{ getEnableName(form.dtypeDisableFlg) }}</span>
          </li>
          <li>
            <span class="label">棚数入力不可フラグ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.opShelfType">
              <option v-for="(disp, index) in dispList" v-bind:key="index" :value="disp.code">{{disp.label}}</option>
            </select>
            <span v-else>{{ dispList[form.opShelfType].label }}</span>
          </li>
          <li>
            <span class="label">フィラー数入力不可フラグ<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.opFillerType">
              <option v-for="(disp, index) in dispList" v-bind:key="index" :value="disp.code">{{disp.label}}</option>
            </select>
            <span v-else>{{ dispList[form.opFillerType].label }}</span>
          </li>
          <li class="sub-menu">
            <span>★連動パーツ番号設定</span>
          </li>
          <li>
            <span class="label">Bタイプ連動有効パーツ番号</span>
            <input v-if="!isComfirm" type="text" v-model="form.dcbOnNo"/>
            <span v-else>{{ form.dcbOnNo }}</span>
          </li>
          <li>
            <span class="label">Bタイプ連動無効パーツ番号</span>
            <input v-if="!isComfirm" type="text" v-model="form.dcbOffNo"/>
            <span v-else>{{ form.dcbOffNo }}</span>
          </li>
          <li>
            <span class="label">Cタイプ連動有効パーツ番号</span>
            <input v-if="!isComfirm" type="text" v-model="form.dccOnNo"/>
            <span v-else>{{ form.dccOnNo }}</span>
          </li>
          <li>
            <span class="label">Cタイプ連動無効パーツ番号</span>
            <input v-if="!isComfirm" type="text" v-model="form.dccOffNo"/>
            <span v-else>{{ form.dccOffNo }}</span>
          </li>
          <li>
            <span class="label">Dタイプ連動有効パーツ番号</span>
            <input v-if="!isComfirm" type="text" v-model="form.dcdOnNo"/>
            <span v-else>{{ form.dcdOnNo }}</span>
          </li>
          <li>
            <span class="label">Dタイプ連動無効パーツ番号</span>
            <input v-if="!isComfirm" type="text" v-model="form.dcdOffNo"/>
            <span v-else>{{ form.dcdOffNo }}</span>
          </li>
          <li class="sub-menu">
            <span>★その他</span>
          </li>
          <li>
            <span class="label">施工の必要有無<span v-if="!isComfirm" class="required">【必須】</span></span>
            <select v-if="!isComfirm" class="select-input" v-model="form.executionFlg">
              <option v-for="(exe, index) in executionList" v-bind:key="index" :value="exe.code">{{exe.label}}</option>
            </select>
            <span v-else>{{ getExecutionName(form.executionFlg) }}</span>
          </li>
          <li>
            <span class="label">オートチェンジャーコード</span>
            <input v-if="!isComfirm" type="text" v-model="form.autoChangerCode"/>
            <span v-else>{{ form.autoChangerCode }}</span>
          </li>
          <li>
            <span class="label">追加発注フィラー固定サイズW</span>
            <input v-if="!isComfirm" type="number" v-model="form.fillerFixW"/>
            <span v-else>{{ form.fillerFixW }}</span>
          </li>
          <li>
            <span class="label">追加発注フィラー固定サイズH</span>
            <input v-if="!isComfirm" type="number" v-model="form.fillerFixH"/>
            <span v-else>{{ form.fillerFixH }}</span>
          </li>
          <li>
            <span class="label">追加発注フィラー固定サイズD</span>
            <input v-if="!isComfirm" type="number" v-model="form.fillerFixD"/>
            <span v-else>{{ form.fillerFixD }}</span>
          </li>
          <li class="sub-menu">
            <span>★公開日時</span>
          </li>
          <li>
            <span class="label">開始</span>
            <input v-if="!isComfirm" type="date" v-model="form.dcStartDate"/>
            <span v-else>{{ form.dcStartDate }}</span>
          </li>
          <li>
            <span class="label">終了</span>
            <input v-if="!isComfirm" type="date" v-model="form.dcEndDate"/>
            <span v-else>{{ form.dcEndDate }}</span>
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['dcFdOrderNo'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['dcDeliveryDay'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['dcFdName'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['dcFdColorType'] }}</p>
      <div class="button-area">
        <button v-if="!isComfirm" type="button" class="main_btn" @click="requestComfirm">公開申請</button>
        <button v-if="!isComfirm" type="button" class="main_btn" @click="onCancel">キャンセル</button>
        <button v-if="isComfirm" type="button" class="main_btn" @click="requestSubmit">申請確定</button>
        <button v-if="isComfirm" type="button" class="main_btn" @click="onCancelComfirm">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'MmstyleRequestModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      fileData: Object,
      isComfirm: false,
      categoryList: [
        {code: 1, label: 'つりと'},
        {code: 2, label: 'カップボード'},
        {code: 3, label: '下駄箱収納'},
        {code: 4, label: 'カウンター'},
        {code: 5, label: '棚'}
      ],
      itemTypeList: [
        {code: 1, label: '板系'},
        {code: 2, label: '吊り戸系'},
        {code: 3, label: 'カップボード系'},
        {code: 4, label: '壁カウンター系'}
      ],
      enableList: [
        {code: 1, label: '有効'},
        {code: 0, label: '無効'}
      ],
      dispList: [
        {code: 0, label: '表示'},
        {code: 1, label: '非表示'},
        {code: 2, label: '選択不可'}
      ],
      executionList: [
        {code: 1, label: '有'},
        {code: 0, label: '無'}
      ],
      colorList: [],
      form: {
        dcCategoryType: '',
        dcFdOrderNo: '',
        dcDeliveryDay: '',
        dcFdName: '',
        dcCaption: '',
        dcFdType: '',
        dcFdColorType: '',
        btypeDisableFlg: '',
        ctypeDisableFlg: '',
        dtypeDisableFlg: '',
        opShelfType: '',
        opFillerType: '',
        dcbOnNo: '',
        dcbOffNo: '',
        dccOnNo: '',
        dccOffNo: '',
        dcdOnNo: '',
        dcdOffNo: '',
        executionFlg: '',
        autoChangerCode: '',
        fillerFixW: '',
        fillerFixH: '',
        fillerFixD: '',
        dcStartDate: '',
        dcEndDate: ''
      },
      errorMessages: [],
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 新規モーダル */
    showModal: function (fileData) {
      this.getColorList()
      this.fileData = fileData
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** 申請内容の確認 */
    requestComfirm: function () {
      let valid = this.valid()
      if (!valid) return
      this.isComfirm = true
    },
    /** 申請内容確認のキャンセル */
    onCancelComfirm: function () {
      this.isComfirm = false
    },
    /** 申請の確定 */
    requestSubmit: function () {
      let payload = this.form
      payload.spaceJoincd = this.fileData.spaceJoincd
      payload.fdId = this.fileData.fdId
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/request/mmstyle', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.modalShown = false
            AppUtil.showModal({
              messages: ['申請しました。']
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** 申請中の取消 */
    requestCancel: function (fileData) {
      let payload = {
        spaceJoincd: fileData.spaceJoincd,
        fdId: fileData.fdId
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/cancel/mmstyle', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.modalShown = false
            AppUtil.showModal({
              messages: ['公開を取り消しました。']
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** カラータイプ一覧取得 */
    getColorList: function () {
      axios.get(API_URL.PLANNING + '/color-type')
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.colorList = response.data.data
          }
          this.clearData()
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** カラータイプ名取得 */
    getColorName: function (no) {
      return this.colorList.find(color => color.cdcColorTypeNo === no).cdcColorTypeName
    },
    /** 有効/無効取得 */
    getEnableName: function (code) {
      return this.enableList.find(enable => enable.code === code).label
    },
    /** 施工の必要有無取得 */
    getExecutionName: function (code) {
      return this.executionList.find(execution => execution.code === code).label
    },
    /** 入力チェック */
    valid: function () {
      this.validateErrorMessages = {}
      let valid = true
      if (!this.form.dcFdOrderNo) {
        this.$set(this.validateErrorMessages, 'dcFdOrderNo', '商品並び順は必須項目です。')
        valid = false
      }
      if (!this.form.dcDeliveryDay) {
        this.$set(this.validateErrorMessages, 'dcDeliveryDay', '配送日数は必須項目です。')
        valid = false
      }
      if (!this.form.dcFdName) {
        this.$set(this.validateErrorMessages, 'dcFdName', 'デジタルカタログ名は必須項目です。')
        valid = false
      }
      if (!this.form.dcFdColorType) {
        this.$set(this.validateErrorMessages, 'dcFdColorType', '商品カラータイプは必須項目です。')
        valid = false
      }
      return valid
    },
    clearData: function () {
      this.isComfirm = false
      this.form = {
        dcCategoryType: this.categoryList[0].code,
        dcFdOrderNo: '',
        dcDeliveryDay: '',
        dcFdName: '',
        dcCaption: '',
        dcFdType: this.itemTypeList[0].code,
        dcFdColorType: this.colorList.length !== 0 ? this.colorList[0].cdcColorTypeNo : '',
        btypeDisableFlg: this.enableList[0].code,
        ctypeDisableFlg: this.enableList[0].code,
        dtypeDisableFlg: this.enableList[0].code,
        opShelfType: this.dispList[0].code,
        opFillerType: this.dispList[0].code,
        dcbOnNo: '',
        dcbOffNo: '',
        dccOnNo: '',
        dccOffNo: '',
        dcdOnNo: '',
        dcdOffNo: '',
        executionFlg: this.executionList[0].code,
        autoChangerCode: '',
        fillerFixW: '',
        fillerFixH: '',
        fillerFixD: '',
        dcStartDate: '',
        dcEndDate: ''
      }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.data-area{
    max-height: 580px;
    overflow: auto;
    padding: 20px 140px;
    li {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      @media (max-width: 768px) {
        flex-direction: column;
      }
      .label {
        flex: none;
        display: inline-block;
        width: 300px;
        text-align: left;
        font-weight: 500;
        margin-left: 20px;
        margin-top: auto;
        margin-bottom: auto;
        @media (max-width: 768px) {
          text-align: left
        }
      }
      .select-input {
        min-width: 190px;
      }
    }
    .sub-menu {
      margin-top: 30px;
      span {
        font-weight: bold;
      }
    }
  }
.modal-main{
  max-height: 90%;
  min-width: 750px;
  max-width: 800px;
}
.count_limit{
  font-size: 8px;
}
.message{
  margin: 30px;
}
.required {
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/MmstyleRequestModal.vue